import { useSelector } from "react-redux";

import { sendRequestToEmision } from "@/redux/actions/vida";
import { formatAmountThousand, addSpaceAfterNChar } from "@/utils/Utils";
import { useDispatch } from "react-redux";
import { encryptAES } from "@/utils/CryptographyUtils";
import { getCodeSecurity } from "@/utils/apiCanal";

export const useSendEmail = () => {
  const { planSelected, nameFrequency, typeOfFinancing } = useSelector(
    (state) => state.plans
  );
  const userData = useSelector((state) => state.vida.userData);
  const adviser = useSelector((state) => state.vida.adviserConfig);
  const { selectedJob, company } = useSelector((state) => state.jobs);
  const currencyPlan = useSelector((state) => state.plans.currencyPlan);

  const dispatch = useDispatch();

  const sendEmail = async () => {
    const sumAssured = addSpaceAfterNChar(planSelected?.sumAssured?.text, currencyPlan === "SOL" ? 2 : 1);
    const savingTime = planSelected?.savingTime?.text;
    const returnPercentage = planSelected?.returnPercentage?.text;

    const replaceToEmail = {
      NAME: userData?.names,
      PRODUCT: "Vida Endosable 100% Digital",
      CURRENCY: currencyPlan === "SOL" ? "S/" : "$",
      FRECUENCY_PAY: nameFrequency,
      INSURED_AMOUNT: sumAssured,
      AMOUNT_TO_PAY: formatAmountThousand(typeOfFinancing.valor),
      PAYMENT_TIME: `${savingTime || ""} años`,
      TOTAL_PERCENT_RETURN: returnPercentage || "0%",
      TOTAL_AMOUNT_RETURN: formatAmountThousand(
        Number(typeOfFinancing.devolucionTotal).toFixed(2)
      ),
      email: getEmailToSend(userData?.email),
    };

    const requestEmision = {
      correo: {
        templateExterno: "mail-purchase-confirmation-endorsement",
        para: [replaceToEmail.email],
        template: "",
        camposDinamicos: encryptAES(
          JSON.stringify({
            nombres: replaceToEmail.NAME,
            producto: replaceToEmail.PRODUCT,
            monto_asegurado: replaceToEmail.INSURED_AMOUNT,
            pago_mensual: `${replaceToEmail.CURRENCY} ${replaceToEmail.AMOUNT_TO_PAY}`,
            plazo_ahorro: replaceToEmail.PAYMENT_TIME,
            porcentaje_devolucion: replaceToEmail.TOTAL_PERCENT_RETURN,
            devolucion_total: `${replaceToEmail.CURRENCY} ${replaceToEmail.TOTAL_AMOUNT_RETURN}`,
          }),
          getCodeSecurity(),
        ),
        de: "RIMAC Digital <rimacdigital@rimac.com.pe>",
        asunto: "¡Compra exitosa!",
      },
      ideTransaccion: planSelected.idCotizacion,
      producto: "vida",
      origen: sessionStorage.getItem("canal") || "web",
      ocupacion: selectedJob?.value,
      correoPago: userData?.email,
      tercero: {
        tipoDocumento: (
          userData?.tipoDocumento ?? userData?.typeDoc
        )?.toString(),
        numeroDocumento: userData?.numeroDocumento ?? userData?.documento,
        correo: userData?.email ?? userData?.correo,
        nombres: userData?.nombres,
        apellidos: `${userData?.apellidoPaterno} ${userData?.apellidoMaterno}`,
      },
      seguro: {
        prima: Number(typeOfFinancing.valor).toFixed(2),
      },
    };

    if (company) {
      requestEmision.nombreEmpresa = company;
    }

    dispatch(sendRequestToEmision(requestEmision));
  };

  const getEmailToSend = (userEmail) => {
    let emailToSend = userEmail;
    if (adviser.hasOwnProperty("id")) {
      const adviserEmail = String(adviser.email).split(",");
      emailToSend = [...[userEmail], ...adviserEmail];
    }
    return emailToSend;
  };

  return { sendEmail };
};
